import React from 'react';
import {
  DividerContainer,
  DividerLine
} from './divider-display.styles';

const DividerDisplay = ({ section }) => {
  const { color = '#ccc', thickness = '1px', width = '100%', style = 'solid' } = section.metadata || {};

  return (
    <DividerContainer>
      <DividerLine
        style={{
          backgroundColor: color,
          height: thickness,
          width: width,
          borderBottom: `${thickness} ${style} ${color}`,
        }}
      />
    </DividerContainer>
  );
};

export default DividerDisplay;